/**
 * Typed localStorage wrapper with JSON serialization
 */

type StorageKey =
  | 'theme'
  | 'sidebar_open'
  | 'last_app_code'
  | 'draft_message'
  | 'notification_permission'
  | 'debug_mode'
  | 'preferred_channel'
  | 'fcm_token'
  | 'template_usage'
  | 'lookup_panel_open'
  | 'lookup_show_by_default'
  | 'app_preferences'
  | 'gd_root_folder_id'
  | 'gd_view_mode'
  | 'gd_show_thumbs'
  | 'voice_numbers_cache';

export function getStorageItem<T>(key: StorageKey, fallback: T): T {
  try {
    const item = localStorage.getItem(`ulgebra_${key}`);
    if (item === null) return fallback;
    return JSON.parse(item) as T;
  } catch {
    return fallback;
  }
}

export function setStorageItem<T>(key: StorageKey, value: T): void {
  try {
    localStorage.setItem(`ulgebra_${key}`, JSON.stringify(value));
  } catch {
    // Storage might be full or blocked
    console.warn(`Failed to save ${key} to localStorage`);
  }
}

export function removeStorageItem(key: StorageKey): void {
  try {
    localStorage.removeItem(`ulgebra_${key}`);
  } catch {
    // ignore
  }
}

export function clearStorage(): void {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('ulgebra_'))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
}
